import { render, staticRenderFns } from "./RenewablesPriceReduction.vue?vue&type=template&id=3c7382cb&"
import script from "./RenewablesPriceReduction.vue?vue&type=script&lang=js&"
export * from "./RenewablesPriceReduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports